export default __webpack_public_path__ + "static/media/MY.c1c681bc.webp";